<template>
  <div class="loader">
    <img src="@/assets/img/loader.svg" alt="">
  </div>
</template>

<script>
export default {
  name:"Loader",
  data(){
    return {
      inicialPositionParent:""
    }
  },
  mounted() {
    //console.log("inicial",this.$parent.$el.style.position)
    this.inicialPositionParent = this.$parent.$el.style.position
    this.$parent.$el.style.position = "relative"
  },
  destroyed(){
    //console.log("destruyendo loader")
    this.$parent.$el.style.position = this.inicialPositionParent
  }
}
</script>

<style lang="scss" scoped>
.loader{
  background: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: absolute;
  z-index: 21;
  display: flex;
  align-items: center;
  justify-content: center;
  img{
    height: auto;
    max-width: 100%;
  }
}
</style>
